import {StrictMode} from 'react';
import * as ReactDOM from 'react-dom/client';

import App from './app/app';
import {EventType, PublicClientApplication, AuthenticationResult} from '@azure/msal-browser';
import { msalConfig } from "@city-sage/aurum-avis-labs-components";
import "./app/core/i18n/i18n"
import { initializeGTM } from './lib/gtm';

const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

// Listen for sign-in event and set active account
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const authResult = event.payload as AuthenticationResult;
    if (authResult.account) {
      msalInstance.setActiveAccount(authResult.account);
      
      // Handle redirect state if present
      if (authResult.state) {
        try {
          const stateData = JSON.parse(authResult.state);
          if (stateData.redirectUrl) {
            // Use setTimeout to ensure navigation happens after other operations
            setTimeout(() => {
              window.location.href = stateData.redirectUrl;
            }, 10);
          }
        } catch (e) {
          console.error('Failed to parse auth state', e);
        }
      }
    }
  }
});

msalInstance.initialize()

// Initialize Google Tag Manager (production only)
initializeGTM();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <App msalInstance={msalInstance}/>
  </StrictMode>
);
